import gql from 'graphql-tag';
import FieldsTeam from "graphql/fields/FieldsTeam";
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'active': '[String]',
	'search': 'String'
};

export default gql(`
	query teams( ${ HelperGraphql.createFields( fields ) } ) {
		teams( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsTeam}
			
			employee_count( ${ HelperGraphql.createVariables( fields ) } )
		}
	}
`);

